module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2_m_en.3bb863fa378cf7c3072b4321e992b3da.png";